export default "__VITE_ASSET__eGSsRzZL__"